import React, { CSSProperties, useContext } from 'react';
import { Typography } from 'tfc-components';

import { IconName } from 'components/atoms/Icon';
import { ContextChatbot } from 'components/templates/MainlayoutChatbot';
import mapModifiers from 'utils/functions';

export interface ActionMessageItem {
  icon: React.ReactNode;
  handleClick?: () => void;
  tooltip?: string;
  activeIcon?: IconName;
  isActive?: boolean;
  disabled?: boolean;
}

interface ActionMessageProps {
  data: ActionMessageItem[];
}

const ActionMessage: React.FC<ActionMessageProps> = ({ data }) => {
  const infoChatbot = useContext(ContextChatbot);
  return (
    <div className="o-actionMessage">
      {data.length > 0
        && data.map((item, index) => (
          <div
            key={`${item.icon}-${index.toString()}`}
            className={mapModifiers('o-actionMessage_item', item.disabled && 'disabled')}
            onClick={item?.handleClick}
            style={{ '--chatbot-color': infoChatbot.mainColor } as CSSProperties}
          >
            <div className={mapModifiers('o-actionMessage_item_icon', item.isActive ? 'active' : 'inactive')}>{item.icon}</div>
            {item.tooltip && <Typography.Text extendClasses="o-actionMessage_tooltip">{item.tooltip}</Typography.Text>}
          </div>
        ))}
    </div>
  );
};

export default ActionMessage;
